<template>
  <div class="section-abstract-header">Contrats</div>
  <div class="section-abstract mb-1">
    <v-row class="ma-0 abstract-row" @click="openSection('SectionContratSalarieListExtend', 'salarie', true)">
      <v-col>
        <div v-if="contratCount <= 0" class="section-abstract-title">Aucun contrat enregistré</div>
        <div v-else class="section-abstract-title">Vous avez {{ contratCount }} contrat(s) enregistré(s)</div>
      </v-col>
      <v-col cols="1" style="align-content: center; align-items: center">
        <v-icon class="arrow-icon" style="font-size: 12px; color: #25A3A7;">
          fas fa-chevron-right
        </v-icon>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
  // Bloc "abstract" de la fiche Salarié : affiche le nombre de contrats du salarié et ouvre,
  // au clic, la liste des contrats filtrée par salarié (SectionContratSalarieListExtend).
  // Calqué sur le bloc Documents (SectionEtablissementDocumentAbstractExtend) + le pendant
  // Salarié généré (SectionSalarieRibAbstract) pour la mécanique openSection.
  import { defineAsyncComponent, defineComponent, markRaw } from "vue";
  import CrudSalarie from '@/generated/cruds/CrudSalarie';
  import { Fiches, Modules } from '@/generated/classes/AppSchema';
  import Route from "@/generated/classes/Route.ts";
  import Section from '@/framework/base/classes/Section';
  import { getSection } from "@/framework/base/helpers/ComponentFinder.ts";
  import Contrat from '@/generated/classes/Contrat';
  import { ColumnFilter, ListChoix, ListFilter } from '@/generated/classes/ListData';

  export default defineComponent({
    components: {},
    extends: CrudSalarie,
    emits: ['openSection'],

    data() {
      return {
        sectionName: 'SALARIE_CONTRAT_ABSTRACT',
        contratCount: 0,
      };
    },

    created(): void {
      if (this.salarie && this.salarie.id > 0) {
        const filter = new ListFilter();
        filter.pageLimit = 1;                       // compteur seul : ne charge aucune ligne inutile
        const columnFilter = new ColumnFilter();
        columnFilter.name = "salarieId";
        columnFilter.staticFilter = true;
        const choix = new ListChoix();
        choix.value = this.salarie.id;
        columnFilter.filters.push(choix);
        filter.columnsFilter.push(columnFilter);
        Contrat.list(filter).then((res) => {
          this.contratCount = res.filteredCount;
        }).catch(() => {
          this.contratCount = 0;
        });
      }
    },

    methods: {
      openSection(componentName: string, objType: string, isList = false): void {
        const route = new Route();
        const section = new Section();
        const loader = getSection(componentName);
        let component = null;
        if (loader) {
          component = markRaw(defineAsyncComponent(loader as any));
        }
        if (isList) {
          route.module = Modules.SALARIE;
          route.fiche = Fiches.CONTAINER;
          route.ficheHeader = this.headerTitle();
          if (component) {
            section.component = component;
          }
          section.propType = objType;
          section.propData = this.salarie;
          // Affiche la liste en pleine largeur (FicheContainerAbstract : col-12 si fullscreen).
          section.fullscreen = true;
          route.data = section;
        }
        this.$emit('openSection', component, route, isList);
      },

      headerTitle(): string {
        return "Contrats de " + this.salarie.prenom + " " + this.salarie.nom;
      },
    },
  })
</script>
